export default __webpack_public_path__ + "static/media/workspace-check.42312cfe.svg";